import React from 'react';
import { getAssetPath } from "../../../lib/assetPath";

interface BackgroundMediaProps {
  backgroundPath: string;
  className?: string;
}

const VIDEO_EXTENSIONS = ['mp4', 'mov', 'webm'] as const;
const IMAGE_EXTENSIONS = ['webp', 'avif'];

export const BackgroundMedia: React.FC<BackgroundMediaProps> = ({
  backgroundPath,
  className = "absolute inset-0 w-full h-full object-cover object-top"
}) => {
  const fileExtension = backgroundPath.split('.').pop()?.toLowerCase();
  const isVideo = VIDEO_EXTENSIONS.includes(fileExtension as any);
  const isImage = IMAGE_EXTENSIONS.includes(fileExtension as any);
  const basePath = backgroundPath.replace(/\.(mp4|mov|webm)$/i, "");
  const webmPath = `${basePath}.webm`;
  const mp4Path = `${basePath}.mp4`;

  if (isVideo) {
    return (
      <video
        key={backgroundPath}
        preload="auto"
        autoPlay
        loop
        muted
        playsInline
        disablePictureInPicture
        className={className}
        style={{ pointerEvents: 'none' }}
      >
        <source src={getAssetPath(webmPath)} type="video/webm" />
        <source src={getAssetPath(mp4Path)} type="video/mp4" />
      </video>
    );
  }

  if (isImage) {
    return (
      <img
        src={getAssetPath(backgroundPath)}
        alt={backgroundPath}
        className={className}
      />
    );
  }

  // Fallback for unknown file types
  return (
    <div className={className} style={{ backgroundColor: '#000' }}>
      <div className="flex items-center justify-center h-full text-white">
        <p>Unsupported media type</p>
      </div>
    </div>
  );
};